import BasketFillIcon from 'mdi-react/BasketFillIcon';
import MonitorCellphone from 'mdi-react/MonitorCellphoneIcon';
import { useSelector } from 'react-redux';
import { URL_OLD_ADMIN } from 'settings';
import { selectUserIsClubeBlack } from 'store/selectors';

import Logo from '../../../assets/Logo';
import Item from './Item';
import Profile from './Profile';
import { Container, Content, Main, LogoContainer } from './styles';

export const Sidebar = () => {
  const isClubeBlack = useSelector(selectUserIsClubeBlack);

  const redirectToOldAdmin = () => {
    window.location.href = `${URL_OLD_ADMIN}`;
  };

  return (
    <Container isClubeBlack={isClubeBlack}>
      <Content>
        <Main>
          <LogoContainer>
            <Logo />
          </LogoContainer>

          <Profile />
          <ul>
            <Item title='Meus Produtos' icon={<MonitorCellphone />} onClick={redirectToOldAdmin} />
            <Item title='Order Bump' icon={<BasketFillIcon />} link='/orderbump' />
          </ul>
        </Main>
      </Content>
    </Container>
  );
};
